import { ITicket } from './ITicket';
import { get } from 'lodash';
export class ProblemsTicket implements ITicket {
    guid: string;
    relations: any;
    id: string;
    name: string;
    creationTime: string;
    ticketId: string;
    topicType: string;
    stateFinal: string;
    stateId: string;
    main: {
        processId: string;
        company: string;
        status: string;
        shortName: string;
        description: string;
        impact: string;
        urgency: string;
        priority: string;
        closureCode: string;
        solution: string;
    };
    details: {
        affectedServiceName: string;
        affectedCI: string;
        rootCause: string;
        workaround: string;
        knownErrorId: string;
        knownError: boolean;
    };


    constructor(
        fromServerTicket: { [key: string]: any },
        statuses: { [key: string]: any },
        prioritys: { [key: string]: any },
    ) {
        const customFieldsValuesMap = statuses[fromServerTicket.state.id];
        this.id = fromServerTicket.id;
        this.guid = fromServerTicket.guid;
        this.ticketId = fromServerTicket.id;
        this.topicType = fromServerTicket.topic_type;
        this.relations = fromServerTicket.relations;
        this.stateFinal = get(fromServerTicket, 'state.final', null),
        this.stateId = get(fromServerTicket, 'state.id', null),
        this.main = {
            processId: fromServerTicket.guid,
            company: fromServerTicket.company.org_name,
            shortName: fromServerTicket.name,
            description: fromServerTicket.description,
            priority: prioritys[fromServerTicket.priority],

            status: get(fromServerTicket, 'state.name', null),
            impact: get(fromServerTicket, 'impact.name', null),
            urgency: get(fromServerTicket, 'urgency.name', null),
            closureCode:
              customFieldsValuesMap && customFieldsValuesMap.ClosureCode && fromServerTicket.customfields &&
              customFieldsValuesMap.ClosureCode[fromServerTicket.customfields.ClosureCode],
            solution: get(fromServerTicket, 'customfields.Solution', null),
        };
        this.details = {
            knownErrorId: fromServerTicket.ke_id || '',
            knownError: fromServerTicket.is_ke !== '0',

            affectedServiceName: get(fromServerTicket, 'service.name', null),
            affectedCI: get(fromServerTicket, 'ci.name', null),
            rootCause: get(fromServerTicket, 'customfields.RootCause', null),
            workaround: get(fromServerTicket, 'customfields.Workaround', null)
        };
    }
}
